"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.intro.start': 'Rozpocznij Onboarding',
    'onboarding.intro.optimize': 'Optymalizuj Obsługę i Procesy',
    'onboarding.intro.moment': 'Nadszedł moment na strategiczne wdrożenie zaawansowanych Asystentów AI.',
    'onboarding.intro.enables': 'Wykorzystanie ich w firmie umożliwia:',
};
